import { render } from "./flash.vue?vue&type=template&id=512a763f"
import script from "./flash.vue?vue&type=script&lang=js"
export * from "./flash.vue?vue&type=script&lang=js"

import "./flash.vue?vue&type=style&index=0&id=512a763f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__